import { AppConfig } from "../../AppConfig";

export const piplineConfigs = {
  methods: {
    isNewUI: function () {
      return AppConfig.newUI == "true" ? true : false;
    },
  },
};
